import styled from 'styled-components'
import { User, UserAll } from '../../models/User'

type Props = {
  instructors: UserAll[]
  onSelectInstructor: (instructor: UserAll) => void
}

function InstructorList(props: Props) {
  return (
    <>
      <Header>강사 선택</Header>
      <Container>
        {props.instructors.map((instructor) => (
          <div
            key={instructor.id}
            onClick={() => props.onSelectInstructor(instructor)}
          >
            {' '}
            {instructor.username}{' '}
          </div>
        ))}
      </Container>
    </>
  )
}

const Header = styled.div`
  text-align: center;
  font-size: 1.2rem;
  padding-bottom: 20px;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  max-height: 80vh;
  div {
    padding: 10px 40px;
    border: 1px solid #ddd;
    margin-bottom: 5px;
    cursor: pointer;

    &:hover {
      background-color: #ddd;
    }
  }
`
export default InstructorList
